import { render, staticRenderFns } from "./MbAirPanel.vue?vue&type=template&id=3a916400"
import script from "./MbAirPanel.vue?vue&type=script&lang=js"
export * from "./MbAirPanel.vue?vue&type=script&lang=js"
import style0 from "./MbAirPanel.vue?vue&type=style&index=0&id=3a916400&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports